module.exports = __webpack_public_path__ + "static/media/bulletin-warning.0e90ae86.svg";